var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('MainNavbar'),_c('router-view',{staticClass:"app__router-view"}),_c('BottomInfoNav'),_c('RightBottomButtonGroup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }